<template>
    <v-container class="content-container pb-14">
        <v-row>
            <v-col>

                <!-- Page title -->
                <div class="page-heading">
                    {{ $t(`ZakljucekPogodbe.Identifikacija.Subtitle`) }}
                </div>

                <div v-if="!dokoncanjePogodbeStore.Pogodba.IsIdentified">
                    <!-- Contract no. -->
                    <div class="d-flex ga-8 align-center mb-4">
                        <img src="@assets/images/contract-list/icon-contract.svg" alt="Pogodba">

                        <div>
                            <div class="contract-details__title">
                                Pogodba {{ dokoncanjePogodbeStore.Pogodba.StPogodbe }}
                            </div>

                            <div class="contract-details__timestamp">
                                <!-- {{ getDateTimeCorrectedFormat(pogodbaDetails.Vneseno) }} -->
                            </div>
                        </div>

                    </div>

                    <!-- Separator -->
                    <hr class="hr mb-8" />

                    <v-row>

                        <!-- Pogodba -->
                        <v-col class="v-col-6">

                            <div class="contract-details__title mb-8">
                                Podrobnosti
                            </div>


                            <!--  -->
                            <div class="contract-details__info">
                                <div class="contract-details__label">{{ $t(`ZakljucekPogodbe.Table.NameSurname`) }}
                                </div>
                                <div>
                                    <div class="contract-details__value">{{
                                        dokoncanjePogodbeStore.Pogodba.ImePriimek }}</div>
                                </div>
                            </div>

                            <!--  -->
                            <div class="contract-details__info">
                                <div class="contract-details__label">{{ $t(`ZakljucekPogodbe.Table.Address`) }}
                                </div>
                                <div>
                                    <div class="contract-details__value">{{ dokoncanjePogodbeStore.Pogodba.Naslov }}
                                    </div>
                                </div>
                            </div>

                            <!--  -->
                            <div class="contract-details__info">
                                <div class="contract-details__label">{{ $t(`ZakljucekPogodbe.Table.BirthDate`) }}
                                </div>
                                <div>
                                    <div class="contract-details__value">{{
                                        getDateCorrectedFormat(dokoncanjePogodbeStore.Pogodba.DatumRojstva)
                                    }}</div>
                                </div>
                            </div>

                            <!--  -->
                            <div class="contract-details__info">
                                <div class="contract-details__label">{{ $t(`ZakljucekPogodbe.Table.TaxNumber`) }}
                                </div>
                                <div>
                                    <div class="contract-details__value">{{ dokoncanjePogodbeStore.Pogodba.DavcnaSt
                                    }}</div>
                                </div>
                            </div>

                            <!--  -->
                            <div class="contract-details__info">
                                <div class="contract-details__label">{{ $t(`ZakljucekPogodbe.Table.TypeOfId`) }}
                                </div>
                                <div>
                                    <div class="contract-details__value">{{ dokoncanjePogodbeStore.Pogodba.OsDokTip
                                    }}</div>
                                </div>
                            </div>

                            <!--  -->
                            <div class="contract-details__info">
                                <div class="contract-details__label">{{ $t(`ZakljucekPogodbe.Table.IssueDate`) }}
                                </div>
                                <div>
                                    <div class="contract-details__value">{{
                                        getDateCorrectedFormat(dokoncanjePogodbeStore.Pogodba.DatumIzdaje)
                                    }}</div>
                                </div>
                            </div>

                            <!--  -->
                            <div class="contract-details__info">
                                <div class="contract-details__label">{{ $t(`ZakljucekPogodbe.Table.ValidateId`) }}
                                </div>
                                <div>
                                    <div class="contract-details__value">
                                        <div
                                            v-if="dokoncanjePogodbeStore.Pogodba.DatumVeljavnosti > '2000-01-01T00:00:00.000'">
                                            {{
                                                getDateCorrectedFormat(dokoncanjePogodbeStore.Pogodba.DatumVeljavnosti)
                                            }}</div>
                                        <div v-else>{{ $t(`ZakljucekPogodbe.Table.PermanentValidity`) }}</div>
                                    </div>
                                </div>
                            </div>

                        </v-col>

                        <v-col class="v-col-6">

                            <div class="contract-details__title mb-8">
                                Identifikacija
                            </div>

                            <div class="mb-6">
                                <label class="form-label">
                                    {{ $t(`ZakljucekPogodbe.IdNumber`) }}
                                </label>
                                <TextInputUppercase variant="outlined"
                                    v-model="dokoncanjePogodbeStore.DokoncanjeIdentifikacijaSisbon.IdNumber"
                                    :error-messages="v$.IdNumber.$errors[0] != null ? v$.IdNumber.$errors[0].$message : ''"
                                    @focus="v$.IdNumber.$reset; dokoncanjePogodbeStore.Pogodba.IdEntryIncorrect = false;">
                                </TextInputUppercase>
                            </div>

                            <!-- Checkbox preverjanje identitete -->
                            <div class="">
                                <v-checkbox
                                    v-model="dokoncanjePogodbeStore.DokoncanjeIdentifikacijaSisbon.IsIdentificationSuccessful"
                                    :error-messages="v$.IsIdentificationSuccessful.$errors[0] != null ? v$.IsIdentificationSuccessful.$errors[0].$message : ''"
                                    @focus="v$.IsIdentificationSuccessful.$reset"
                                    :label="$t(`ZakljucekPogodbe.Label`)"></v-checkbox>
                            </div>

                            <!-- Error for missmatched id number -->
                            <div class="notification notification--warning"
                                v-if="dokoncanjePogodbeStore.Pogodba.IdEntryIncorrect">
                                <div>
                                    <div class="mb-2">
                                        {{ $t(`ZakljucekPogodbe.IdNumberIncorrect1`) }}
                                    </div>
                                    <div>
                                        {{ $t(`ZakljucekPogodbe.IdNumberIncorrect2`) }}
                                    </div>
                                </div>
                            </div>

                            <!-- Btn SISBON-->
                            <div class="mt-8 mb-8 d-flex align-center ga-4">
                                <v-btn
                                    :disabled="dokoncanjePogodbeStore.Pogodba.IdEntryIncorrect || (dokoncanjePogodbeStore.FormState.SisbonCheckInProgress == true || dokoncanjePogodbeStore.Pogodba.DisableSisbonBtn)"
                                    @click="CheckSisbon()" class="btn btn--primary-fill ">
                                    {{ $t(`ZakljucekPogodbe.BtnSisbon`) }}
                                </v-btn>

                                <!-- Btn Prekliči vlogo -->
                                <v-btn v-if="dokoncanjePogodbeStore.Pogodba.IdEntryIncorrect"
                                    :disabled="dokoncanjePogodbeStore.FormState.SisbonCheckInProgress == true || dokoncanjePogodbeStore.Pogodba.DisableSisbonBtn"
                                    @click="CancelContract()" class="btn btn--primary-fill">
                                    {{ $t(`ZakljucekPogodbe.BtnPreklicVloge`) }}
                                </v-btn>
                            </div>

                        </v-col>
                    </v-row>

                    <v-row v-if="dokoncanjePogodbeStore.FormState.IsSisbonSuccess">

                        <div class="mt-8 mb-8 d-flex align-center ga-4">
                            <!-- Btn BACK-->
                            <v-btn @click="dokoncanjePogodbeStore.restore()" class="btn btn--primary-fill">
                                {{ $t(`ZakljucekPogodbe.BackToContract`) }}
                            </v-btn>
                        </div>

                    </v-row>

                </div>

                <div v-else>

                    <v-row>
                        <v-col>
                            <div v-if="dokoncanjePogodbeStore.FormState.SisbonCheckInProgress">
                                <div class="text-center">
                                    <div class="loader-large--not-fixed mt-16">
                                        <img src="@assets/images/general/loader-nlb-large.svg" alt="Loader">
                                    </div>
                                    <div class="subsection-heading mt-4 mb-4">
                                        Poteka SISBON preverjanje. Prosimo, počakajte.
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="dokoncanjePogodbeStore.FormState.IsSisbonSuccess">
                                    <div class="notification notification--success mt-4">
                                        SISBON preverjanje je bilo uspešno.
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="notification notification--warning mt-4">
                                        SISBON preverjanje ni bilo uspešno. Pogodba je preklicana.
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>

            </v-col>
        </v-row>

        <!-- Modal dokumentacija informacija-->
        <Modal title="Dokumentacija" @modalClosed="dokumentacijaInformacija = false" :display="dokumentacijaInformacija"
            closeText="Zapri" :showAcceptButton="false">
            <div v-html="dokoncanjePogodbeStore.Pogodba.TipDokumentacije"></div>
        </Modal>

    </v-container>
</template>

<script setup lang="ts">
    import { Ref, ref, computed } from "vue";
    import { useDokoncanjePogodbeStore } from "@/app/store/app/contract-completion/store";
    import { getDateCorrectedFormat } from "@/app/utils/date-functions";
    import Modal from "@/app/components/modal.vue";
    import { i18n } from "@app/i18n";
    import { useVuelidate } from "@vuelidate/core";
    import { helpers, required, sameAs } from "@vuelidate/validators";
    import { useFw4Store, MessageBoxPredefinedButtons, MessageBoxButtonType } from "fw4-library";
    import TextInputUppercase from "@components/text-input-uppercase.vue";

    const dokoncanjePogodbeStore = useDokoncanjePogodbeStore();
    const fwStore = useFw4Store();

    //show dokumentacija modal
    let dokumentacijaInformacija: Ref<boolean> = ref(false);

    dokoncanjePogodbeStore.Steps.Pogodba.disabled = true;
    dokoncanjePogodbeStore.Steps.Dokumentacija.disabled = true;
    dokoncanjePogodbeStore.Steps.Identifikacija.disabled = false;
    dokoncanjePogodbeStore.Steps.Zakljucek.disabled = true;
    dokoncanjePogodbeStore.Steps.Pogodba.done = true;
    dokoncanjePogodbeStore.Steps.Dokumentacija.done = true;

    if (dokoncanjePogodbeStore.Pogodba.IsIdentified) {
        if (dokoncanjePogodbeStore.Pogodba.SisbonCompleted) {
            dokoncanjePogodbeStore.pogodbaPodpisLater();
        } else {
            dokoncanjePogodbeStore.checkSisbon();
        }
    }

    async function CheckSisbon() {
        await validateForm().then(() => {
            CheckSisbonInternal();
        });
    }

    async function CheckSisbonInternal() {
        if (dokoncanjePogodbeStore.Pogodba.OsDokSt.toLowerCase() != dokoncanjePogodbeStore.DokoncanjeIdentifikacijaSisbon.IdNumber.toLowerCase()) {
            dokoncanjePogodbeStore.Pogodba.IdEntryIncorrect = true;
        } else {
            dokoncanjePogodbeStore.Pogodba.DisableSisbonBtn = true;
            dokoncanjePogodbeStore.Pogodba.IsIdentified = true;
            dokoncanjePogodbeStore.checkSisbon()
        }
    }

    async function CancelContract() {
        await fwStore.ShowMessageBox(i18n.global.t("ZakljucekPogodbe.CancelTitle"), i18n.global.t("ZakljucekPogodbe.CancelQuestion"), [
            MessageBoxPredefinedButtons[MessageBoxButtonType.Cancel],
            MessageBoxPredefinedButtons[MessageBoxButtonType.OK]    
        ]).then((buttonId: string) => {
            if (buttonId == "OK") {
                dokoncanjePogodbeStore.cancelContract()
            }
        })
    }

    async function validateForm(): Promise<void> {
        v$.value.$touch();
        let formValid = await v$.value.$validate();
        return new Promise((resolve) => {
            if (formValid) {
                resolve();
            }
        });
    };

    const validationRules = computed(() => ({
        IsIdentificationSuccessful: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.VALID_IDENTIFICATION"), sameAs(true)),
        },
        IdNumber: {
            required: helpers.withMessage(i18n.global.t("GlobalErrors.FIELD_REQUIRED"), required),
        }

    }));

    const v$: any = useVuelidate(validationRules, dokoncanjePogodbeStore.DokoncanjeIdentifikacijaSisbon, { $autoDirty: true });
</script>